export function JsonSyntax({ value, depth = 0 }: { value: unknown; depth?: number }) {
  if (value === null) return <span className="text-muted-foreground">null</span>;
  if (typeof value === 'boolean')
    return <span className="text-status-warning">{String(value)}</span>;
  if (typeof value === 'number')
    return <span className="text-status-success">{String(value)}</span>;
  if (typeof value === 'string') {
    const display = value.length > 200 ? value.slice(0, 200) + '…' : value;
    return <span className="text-status-accent-sky">&quot;{display}&quot;</span>;
  }

  if (Array.isArray(value)) {
    if (value.length === 0) return <span className="text-muted-foreground">{'[]'}</span>;
    const indent = '  '.repeat(depth);
    const childIndent = '  '.repeat(depth + 1);
    return (
      <>
        <span className="text-muted-foreground">{'['}</span>
        {'\n'}
        {value.map((item, i) => (
          <span key={i}>
            {childIndent}
            <JsonSyntax value={item} depth={depth + 1} />
            {i < value.length - 1 ? ',' : ''}
            {'\n'}
          </span>
        ))}
        {indent}
        <span className="text-muted-foreground">{']'}</span>
      </>
    );
  }

  if (typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>);
    if (entries.length === 0) return <span className="text-muted-foreground">{'{}'}</span>;
    const indent = '  '.repeat(depth);
    const childIndent = '  '.repeat(depth + 1);
    return (
      <>
        <span className="text-muted-foreground">{'{'}</span>
        {'\n'}
        {entries.map(([k, v], i) => (
          <span key={k}>
            {childIndent}
            <span className="text-status-accent-purple">&quot;{k}&quot;</span>
            <span className="text-muted-foreground">: </span>
            <JsonSyntax value={v} depth={depth + 1} />
            {i < entries.length - 1 ? ',' : ''}
            {'\n'}
          </span>
        ))}
        {indent}
        <span className="text-muted-foreground">{'}'}</span>
      </>
    );
  }

  return <span>{String(value)}</span>;
}
